import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid, Stack } from '@mui/material'
import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { CardTitle } from '../card/NewCard'
import Input from '../forms/Input'
import SimpleDatePicker from '../forms/SimpleDatePicker'
import Select from '../forms/Select'
import { SANDRE } from '../../referencial/constants/ReferencialConstants'
import SimpleTextArea from '../forms/SimpleTextArea'
import { getReferencialComponent } from '../../referencial/util/ReferencialUtils'
import ContactDto from '../../referencial/components/contact/dto/ContactDto'
import useSandreList from '../../utils/customHook/useSandreList'
import { shallowEqual, useSelector } from 'react-redux'
import { greyBlue } from '../../utils/constants/ColorTheme'

const DialogContact = ({
    isOpen,
    setIsOpen,
    contact,
}) => {
    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    return (
        <Dialog
            onClose={() => setIsOpen(false)}
            fullWidth
            maxWidth='lg'
            open={isOpen}
        >
            <DialogContent>
                <Stack width={'100%'} spacing={1}>
                    <Card>
                        <CardTitle title={i18n.description} color={greyBlue} />
                        <CardContent>
                            <Grid container columnSpacing={1}>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.title}
                                        value={contact.title}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={9}>
                                    <Input
                                        title={i18n.name}
                                        value={contact.name}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={i18n.socialReason}
                                        value={contact.socialReason}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <SimpleDatePicker
                                        style={{ padding: 0 }}
                                        label={i18n.birthdate}
                                        value={contact.birthdate}
                                        readMode
                                        onChange={() => {}}
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        label={i18n.functions}
                                        value={contact.contactFunction}
                                        options={useSandreList(SANDRE.CONTACTS_FONCTIONS)}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <SimpleTextArea
                                        title={i18n.comment}
                                        value={contact.comment}
                                        readMode
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={i18n.localisation} color={greyBlue} />
                        <CardContent>
                            <Grid container columnSpacing={1}>
                                <Grid size={12}>
                                    <SimpleTextArea
                                        title={i18n.address}
                                        value={contact.address}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <SimpleTextArea
                                        title={i18n.additionnalAddress}
                                        value={contact.additionalAddress}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.postalCode}
                                        value={contact.postalBox}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={9}>
                                    <Select
                                        label={i18n.city}
                                        value={contact.cityCode}
                                        options={getReferencialComponent(cities)}
                                        readMode
                                        clearFunction
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.cedexCode}
                                        value={contact.cedex}
                                        readMode
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={i18n.coordinates} color={greyBlue}/>
                        <CardContent>
                            <Grid container columnSpacing={1}>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.phoneTel}
                                        value={contact.phoneTel}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.phoneTelSecond}
                                        value={contact.phoneTelSecond}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={i18n.fax}
                                        value={contact.fax}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.desktopTel}
                                        value={contact.desktopTel}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={i18n.mobile}
                                        value={contact.mobile}
                                        readMode
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={i18n.email}
                                        value={contact.email}
                                        readMode
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setIsOpen(false)} variant='outlined' color='secondary'>
                    {i18n.close}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogContact.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    contact: PropTypes.instanceOf(ContactDto).isRequired,
}

export default DialogContact